import { render } from "./TraderOperatorForm.vue?vue&type=template&id=0adf912b&ts=true"
import script from "./TraderOperatorForm.vue?vue&type=script&lang=ts"
export * from "./TraderOperatorForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__